<template>
  <footer>
      &copy;The Great Kids Show
  </footer>
</template>

<script>
export default {
name: "footer",
}
</script>

<style scoped>
footer{
color:white;
}
</style>